export const textOverflowClasses = {
    truncate: 'truncate',
    ellipsis: 'text-ellipsis',
    clip: 'text-clip',
};
